const faqs = [
  {
    q: '51吃瓜网的信息来源可靠吗？',
    a: '51吃瓜网官网的信息来源于公开网络、社交媒体、媒体报道及用户投稿，经编辑团队人工核实后发布。对于爆料类内容，平台会标注"爆料"标签，供读者自行判断真伪。我们始终坚持内容审核标准，不传播未经证实的恶意谣言。',
  },
  {
    q: '51吃瓜黑料网和51吃瓜爆料网有什么区别？',
    a: '51吃瓜爆料网侧重于明星网红的最新动态和事件报道，以快讯和热点追踪为主；51吃瓜黑料网则更关注人物内幕、行业潜规则等深度内容。两者互为补充，共同构成51吃瓜网的完整内容生态。访问官网即可同时浏览两类内容。',
  },
  {
    q: '如何向51吃瓜网投稿或爆料？',
    a: '欢迎通过页面下方的联系方式提交线索。请确保所提供的信息真实可靠，并提供尽可能详细的证据材料。对于具有重大新闻价值的独家爆料，编辑团队会优先处理并给予反馈。',
  },
  {
    q: '51吃瓜网今日吃瓜资源多久更新一次？',
    a: '51吃瓜网今日吃瓜资源实行全天候滚动更新机制。热搜榜单每5分钟自动刷新，快讯频道随时更新最新动态，话题标签实时反映当前讨论热度。建议收藏本站并开启通知，确保不错过任何重要爆料。',
  },
  {
    q: '51吃瓜网有手机APP吗？',
    a: '有的！51吃瓜网提供iOS和Android双端APP，支持离线阅读、热点推送、个性化话题订阅等功能。APP端内容更新速度更快，体验更流畅。可以点击页面中的"APP下载"区域获取安装方式。',
  },
  {
    q: '如何在51吃瓜网找到自己感兴趣的话题？',
    a: '你可以通过首页的话题广场浏览热门标签，也可以通过主题索引快速定位感兴趣的领域。平台支持按明星、网红、综艺、影视等分类浏览。此外，导航栏提供了热门榜单、最新动态等快捷入口，方便快速查看当前最热内容。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-1 h-6 bg-secondary-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            常见问题
          </h2>
        </div>
        <p className="text-sm text-foreground-600 mb-8 ml-4">关于51吃瓜网你想知道的都在这里</p>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, idx) => (
            <div key={idx} className="bg-background-50 rounded-2xl overflow-hidden">
              <div className="px-6 py-5">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 flex items-start gap-2">
                  <span className="text-primary-500 font-bold shrink-0">Q{idx + 1}.</span>
                  {faq.q}
                </h3>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed pl-7">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}